import { render, staticRenderFns } from "./AccidentReportForm.vue?vue&type=template&id=d467ccc8&scoped=true"
import script from "./AccidentReportForm.vue?vue&type=script&lang=js"
export * from "./AccidentReportForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d467ccc8",
  null
  
)

export default component.exports